module.exports = __webpack_public_path__ + "static/part-13-a912ccd5077570e9e5104b4d7b908c3c.svg";